import { usePathInOrg } from '@/org/hooks/usePathInOrg'

// The What's new page (#77) opens inside the current organization, so its
// sidebar stays in place; outside any organization, the page on its own.
export function useWhatsNewPath(): string {
  return usePathInOrg('whats-new') || '/whats-new'
}
